import { render, staticRenderFns } from "./DisabledPrimaryFlat.vue?vue&type=template&id=15b97dc9"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports